module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d23462ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Appointments/Appointments.vue
// module id = 1463
// module chunks = 0